import { FC } from "react";

import { OverviewScatterChartTooltipProps } from "./types";
import { EyeIcon, SentimentPositiveIcon } from "../../icons";

import styles from "./OverviewScatterChartTooltip.module.css";

const OverviewScatterChartTooltip: FC<OverviewScatterChartTooltipProps> = ({
  active,
  payload,
}) => {
  if (!active || !payload?.length) {
    return null;
  }

  const point = payload[0].payload;
  if (!point) {
    return null;
  }

  const visibility = Math.round(point.visibility);
  const sentiment = Math.round(point.sentiment);

  return (
    <div
      className={styles["overview_scatter_chart_tooltip"]}
      role="tooltip"
      aria-label={`Visibility ${visibility}%, Sentiment ${sentiment}%`}
    >
      <div className={styles["overview_scatter_chart_tooltip__item"]}>
        <EyeIcon
          className={styles["overview_scatter_chart_tooltip__icon"]}
          aria-hidden
        />
        <p className={styles["overview_scatter_chart_tooltip__value"]}>
          {visibility}
        </p>
      </div>
      <div className={styles["overview_scatter_chart_tooltip__item"]}>
        <SentimentPositiveIcon
          className={styles["overview_scatter_chart_tooltip__icon"]}
          aria-hidden
        />
        <p className={styles["overview_scatter_chart_tooltip__value"]}>
          {sentiment}
        </p>
      </div>
    </div>
  );
};

export default OverviewScatterChartTooltip;
